export enum SlotKind {
	ADULT = 'A',
	CHILD = 'C',
}
